// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__v5pbv","log":"ModalInventoryLogs_log__2s8pI","date":"ModalInventoryLogs_date__2blgS","userName":"ModalInventoryLogs_userName__3CHRL"};